<template>
  <div>
    <topbar :menu="false" title="Verifica E-Mail" />

    <div class="p-3 max-w-3xl mx-auto w-full">
      <card title="Grazie!">
        <div>Ti abbiamo inviato un'email con il link per verificare il tuo indirizzo di posta elettronica per proseguire con la registrazione.</div>

        <div class="my-2 text-gray-500">
          <span class="italic" v-if="waiting">Inviata</span>
          <span class="italic" v-else-if="sending">Invio...</span>
          <span class="underline" @click="resendEmail" v-if="!sending && !waiting">Invia di nuovo la mail di verifica</span>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      timer: 0,
      sending: false,
      waiting: false
    }
  },
  mounted() {
    if(this.verified) {
      this.$router.push({name: 'Overview'})
    } else {
      this.timer = setInterval(() => {
        this.$store.dispatch('reloadUser')
      }, 5000);
    }

  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  computed: mapState({
    verified: state => state.auth.verified
  }),
  watch: {
    verified(val) {
      if(val) {
        this.$router.push({name: 'Overview'})
      }
    },
  },
  methods: {
    async resendEmail() {
      this.sending = true
      await this.$store.dispatch('sendEmailVerification')
      this.waiting = true
      this.sending = false
      setTimeout(() => {
        this.waiting = false
      }, 15000);
    }
  }
}
</script>

<style>

</style>